$(document).ready(function () {

	function fixHeader() {
		var head = $('.page_header');
		var main = $('.first_block');
		var heightHead = head.height();
		// var anchor = $('.js-service-anchor');

		// head.addClass('fixed');
		main.css('padding-top', heightHead);

		// anchor.each(function(){
			// $(this).css('top', heightHead * -1);
		// })

	}
	fixHeader();
	jQuery(window).resize(fixHeader);


	$('.contact_item').mouseenter(function(){
		if($(this).hasClass('js-anim')) {
			var width = 0
			width = parseInt($(this).css('width')) + parseInt($(this).find('.phone_link').css('width')) + parseInt($(this).find('svg').css('width'));
			$(this).css('width', width)
		}
	})
	$('.contact_item').mouseleave(function(){
		if($(this).hasClass('js-anim')) {
			var width = '6.7em';
			$(this).css('width', width)
		}
	})



	function headerScrollCollapse() {
		var head = $('.page_header');
		var scroll = $(window).scrollTop();

		if(scroll > 100) {
			head.addClass('collapsed');
		} else {
			head.removeClass('collapsed');
		}

	}
	headerScrollCollapse();
	jQuery(window).scroll(headerScrollCollapse);



	function checkPhotos() {
		$('.img_wrapper.wow').each(function(){
			$(this).css('visibility', 'visible');
		})
	}
	setTimeout(function(){
		// checkPhotos();
	}, 500);


	// wow = new WOW();
	// wow.init();



function getCurrentBreadCrumb() {
	var slot = $('.js-current-br-page');
	var title = $('h1').text();

	// console.log(title)

	slot.text(document.title);
}
getCurrentBreadCrumb();



	function getActiveSidebar() {
		var url = window.location;
		console.log(url.pathname)
		$('.service_link').each(function () {
			var href = $(this).attr('href');
			if (href == url.pathname) {
				$(this).addClass('active');
				$(this).parents('.services_list').addClass('visible');
			}
		});
	}
	getActiveSidebar();

	$(document).on('click', '.burger_wrapper', function (e) {
		e.preventDefault();
		$('.burger').toggleClass('active');
		$('.menu_wrapper').toggleClass('opened');
		$('body').toggleClass('fix');
	  });

	  $(document).on('click', 'main', function (e) {
		$('.burger').removeClass('active');
		$('.menu_wrapper').removeClass('opened');
		$('body').removeClass('fix');
	  });


	$('.services_list .text_size_lm').on('click', function(e){
		$('.services_list').removeClass('visible');
		$(this).parents('.services_list').addClass('visible')
	})

	$(function () {
		$("a[href^='#']").bind('click', function (e) {
			var winWidth = $(window).width();
			var headerHeight = $('.page_header').height();
			var _href = $(this).attr("href");
			var target = 0;
			if ($(this).hasClass('js-feedback-link') && !$('.page_body').hasClass('_index')) {
				e.preventDefault();
			} else {
				target = $(_href).offset().top;
			}
			$("html, body").animate({
				scrollTop: target + "px"
			}, 800);
			return false;
		});
	});

	$('.js-feedback-link').on('click',function(e){
		if(!$('.page_body').hasClass('_index')) {
			e.preventDefault();
			window.location.replace("/#feedback_block");
		}
	})


	function flatScroll() {
		if (window.location.hash) {
			var type = window.location.hash.split('#')[1].split('-')[0];
			var headerHeight = $('.page_header').height();
			if (type == 'flat') {
				$("html, body").animate({
					scrollTop: ($('#ongCheckerboardModule').offset().top - headerHeight) + "px"
				}, 800);
			}
			if (window.location.hash == '#complete-objects') {
				$("html, body").animate({
					scrollTop: ($('#complete-objects').offset().top - headerHeight) + "px"
				}, 800);
			}
		}
	}
	setTimeout(() => {
		flatScroll();
	}, 300);




	function imgRatio() {
		if($('.cards').hasClass('cards--complete')) {
			$('.img_wrapper').each(function(){
				var blockWidth = parseInt($(this).width());
				var blockHeight = parseInt($(this).height());
				var blockRatio = blockWidth / blockHeight;

				var imgWidth = parseInt($(this).find('img').width());
				var imgHeight = parseInt($(this).find('img').height());
				var imgRatio = imgWidth / imgHeight;

				// console.log(screenRes);

				if (blockRatio < imgRatio) {
					$(this).find('img').css({ 'width': '100%', 'height': 'auto' });
				} else {
					$(this).find('img').css({ 'width': 'auto', 'height': '100%' });
				}
			})
		}
	}
	imgRatio();
	// setTimeout(imgRatio, 200);
	jQuery(window).resize(imgRatio);

	$(window).load(function () {

		imgRatio();

	});







	function contactsMap() {
		if($('div').hasClass('map_wrapper')) {
			ymaps.ready(function () {
				var myMap = new ymaps.Map('contactsMap', {
						center: [52.584757, 39.580185],
						zoom: 16,
						controls: []
					}, {
						searchControlProvider: 'yandex#search'
					}),

					// Создаём макет содержимого.
					MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
						'<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
					),

					myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
						hintContent: 'ул. 50 лет НЛМК, д. 11'
					}, {
						// Опции.
						// Необходимо указать данный тип макета.
						iconLayout: 'default#image',
						// Своё изображение иконки метки.
						iconImageHref: '/static/site_templates/ecolog48/imgs/placemark.svg',
						// Размеры метки.
						iconImageSize: [50, 50],
						// Смещение левого верхнего угла иконки относительно
						// её "ножки" (точки привязки).
						iconImageOffset: [-25, -25]
					});

				myMap.geoObjects
					.add(myPlacemark)
			});

		}
	}
	contactsMap();





});
